import { ajaxSpinner } from '../util/ajaxSpinner';

export default {
  init() {
  },
  finalize() {

    /**
     * Load more
     */
    $('#load-more').click(function () {
      $(this).hide();
      load_news();
    });

    function load_news() {

      var is_intranet = $('body').data('is-intranet');

      /**
       * Category query
       */
      var urlParams = new URLSearchParams(window.location.search);
      var cat = urlParams.get('category');

      /**
       * Get current page.
       */
      var current_page = parseInt($('#load-more').data('page'));
      const spinner = new ajaxSpinner($('.news-items-container'));
      const lang = $('body').data('lang');

      $.ajax({
        url: `/wp-json/news-api/v1/get?page=${current_page}`,
        data: {
          page: current_page,
          _wpnonce: $('body').data('nonce'),
          category: cat,
          intranet: is_intranet,
          lang: lang,
        },
      })
        .done(function (res) {

          // Append posts to page.
          var read_more = (lang == 'cy' ? 'Darllen mwy' : 'Read more');

          res.posts.forEach(function (post) {
            var post_permalink = post.permalink;

            if (post.acf.listing_style == 'image') {

              var featuredImg = '';
              if (post.featured) {
                featuredImg = `<div class="image-container"><img src="${post.featured}" class="image-inner" /></div>`;
              }
              

              var o = `
                <div class="news-item news-item-image" data-aos="fade-up" data-aos-duration="400">
                  ${featuredImg}
                  <div class="meta-container">
                    <span class="meta" data-aos="fade-up" data-aos-duration="400" data-aos-delay="200"> ${post.tags} | ${post.date}</span>
                    <a href="${post_permalink}" data-aos="fade-up" data-aos-duration="400" data-aos-delay="300"><span class="title">${post.post_title}</span></a>
                    <p class="excerpt mb-5" data-aos="fade-up" data-aos-duration="400" data-aos-delay="400">${post.post_excerpt}</p>
                    <a href="${post_permalink}" class="link-green underline-hover" data-aos="fade-up" data-aos-duration="400" data-aos-delay="500">${read_more}</a>
                  </div>
                </div>

                <hr class="news-separator">`;

              $('.news-items-container').append(o);

              (o)
            } else {
              o = `
                <div class="news-item news-item-${post.acf.listing_style}" data-aos="fade-up" data-aos-duration="400">
                  <div class="meta-container">
                    <span class="meta" data-aos="fade-up" data-aos-duration="400" data-aos-delay="200"> ${post.tags} | ${post.date}</span>
                    <span class="title" data-aos="fade-up" data-aos-duration="400" data-aos-delay="300">${post.post_title}</span>
                    <p class="excerpt" data-aos="fade-up" data-aos-duration="400" data-aos-delay="400">${post.post_excerpt}</p>
                  </div>
                  <a href="${post_permalink}" class="underline-hover" data-aos="fade-up" data-aos-duration="400" data-aos-delay="500">${read_more}</a>
                </div>

                <hr class="news-separator">`

              $('.news-items-container').append(o);
            }

            if (res.found_posts !== 6) {
              $('#load-more').fadeOut();
            }
          })

          /*
           * Update page.
           */
          $('#load-more').data('page', current_page + 1);
          $('#load-more').show();
          spinner.remove();
        })
      .error(function () {
        console.log('Error retrieving data, trying again.');
        load_news();
      })
    }

    load_news()
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/template-news-listing.js